import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RequestState } from '../../../shared/definitions/request-state.enum';
import { SimXReleaseTag } from '../../../shared/models/entities/simx-release-tag.model';
import { State } from './release-tag-store.state';

const getReleaseTagsRequestState = (state: State): RequestState =>
  state.releaseTagsRequestState;
const getReleaseTags = (state: State): Array<SimXReleaseTag> =>
  state.releaseTags;

export const selectReleaseTagState = createFeatureSelector<State>('releaseTag');

export const selectReleaseTagsRequestState = createSelector(
  selectReleaseTagState,
  getReleaseTagsRequestState,
);
export const selectReleaseTags = createSelector(
  selectReleaseTagState,
  getReleaseTags,
);
